import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../redux/rootReducer';
import { localStorageMiddleware, promiseMiddleware } from '../middleware/api';

const configureStore = preloadedState => {
  return createStore(
    rootReducer,
    preloadedState,
    compose(applyMiddleware(promiseMiddleware, localStorageMiddleware))
  );
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js